<template>
  <div>
    <el-tooltip class="item" effect="light" :content="$t('post.sidebar.reportButton')" placement="top">
      <el-button type="primary" icon="el-icon-edit" circle @click="openCreateReportWindow"></el-button>
    </el-tooltip>

    <el-divider />

    <ul class="post-report-wrap">
      <li class="post-report-wrap__item" @click="openReportModal(csvLinkLight)">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[0]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" >
            <div class="in_link-wrap">
              <i class="fas fa-file fa-4x"></i>
              <span>{{$t('post.sidebar.reports[0]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal(topSource)">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[1]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false">
            <div class="in_link-wrap">
              <i class="far fa-file-excel fa-4x"></i>
              <span>{{$t('post.sidebar.reports[1]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal(fileDownloadLink)">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[2]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false">
            <div class="in_link-wrap">
              <i class="far fa-file-excel fa-4x"></i>
              <span>{{$t('post.sidebar.reports[2]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal(fileDownloadLinkExcel)">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[3]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false">
              <div class="in_link-wrap">
                <i class="far fa-file-excel fa-4x"></i>
                <span>{{$t('post.sidebar.reports[3]')}}</span>
              </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[4]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" @click="openReportDialogSettings()">
            <div class="in_link-wrap" >
              <i class="far fa-file-word fa-4x"></i>
              <span>{{$t('post.sidebar.reports[4]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal(dayLink)">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[5]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false">
              <div class="in_link-wrap">
                <i class="far fa-file-word fa-4x"></i>
                <span>{{$t('post.sidebar.reports[5]')}}</span>
              </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal(weekLink)">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[6]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false">
              <div class="in_link-wrap">
                <i class="far fa-file-word fa-4x"></i>
                <span>{{$t('post.sidebar.reports[6]')}}</span>
              </div>
          </el-link>
        </el-tooltip>
      </li>
      <li v-if="sourcesCount > 0" class="post-report-wrap__item" @click="openReportModal(metaReportExcel)">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[7]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" >
              <div class="in_link-wrap">
                <i class="far fa-file-excel fa-4x"></i>
                <span>{{$t('post.sidebar.reports[7]')}}</span>
              </div>
          </el-link>
        </el-tooltip>
      </li>

    </ul>

    <el-dialog title="Сформировать отчет" :visible.sync="dialogReportVisible" width="380px">
        <el-form :model="reportForm">
          <el-form-item label="По">
            <el-select v-model="reportForm.typeReport" placeholder="Тип группировки">
              <el-option :label="type" :value="index" v-for="(type, index) in reportForm.items" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Формат">
            <el-radio-group v-model="reportFileType">
              <el-radio label="docx">Docx</el-radio>
              <el-radio label="pdf">Pdf</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer dialog-footer--report">
          <el-button @click="dialogReportVisible = false">Отмена</el-button>
          <el-button type="primary" @click="okModal()" style="margin-left: 15px">Загрузить</el-button>
        </span>
    </el-dialog>
    <el-dialog title="Формирование отчет" :visible.sync="modalReportVisible" width="380px">
      <p>Идёт формирование отчёта. Это может занять несколько минут. Пожалуйста, не покидайте страницу, пока не завершится загрузка. Отчёт сохранится в папку "Загрузки" на вашем компьютере.
      </p>

        <span slot="footer" class="dialog-footer dialog-footer--report">
          <el-button @click="modalReportVisible = false">ОK</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  // vuex
  import { mapGetters } from 'vuex';
  import { getMetaSourcesApi, getReportApi} from "../../../../../../../../api/feeds";


  // libraries
  import moment from "moment/moment";

    const convert = (resp) => {
    let base64String = resp.content;
    const base64Data = base64String.replace(/^data:.+;base64,/, "");
    const byteCharacters = atob(base64Data); // Decode Base64 string
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: resp.mime });
    const url = URL.createObjectURL(blob);

    // Create a link element to download the file
    const link = document.createElement("a");
    link.href = url;
    link.download = resp.filename;
    link.click();

    // Cleanup
    URL.revokeObjectURL(url);
  };

  export default {
    name: 'Report',
    props: {
      csvLinkLight: {
        type: String
      },
      weekLink: {
        type: String
      },
      dayLink: {
        type: String
      },
      topSource: {
        type: String
      },
      fileDownloadLink: {
        type: String
      },
      fileDownloadLinkExcel: {
        type: String
      },
      metaReportExcel: {
        type: String
      },
      dates: {
        type: Object
      }
    },
    data() {
      return {
        dialogReportVisible: false,
        modalReportVisible: false,
        reportForm: {
          typeReport: 'day',
          items: {
            day: "Дням",
            week: "Неделям",
            month: 'Месяцам',
            quart: "Кварталам",
          }
        },
        reportFileType: 'docx',
        sourcesCount: 0,
      };
    },
    methods: {
      openCreateReportWindow() {
        this.$emit('openCreateReportWindow');
      },
      openReportDialogSettings() {
        this.dialogReportVisible = true;
      },
      openReportModal(link) {
        this.modalReportVisible = true;
        getReportApi(link).then(resp => {
            convert(resp.data)
        });
      },
      okModal() {
        this.dialogReportVisible = false;
        let date_from = moment(this.dates.date_from).format("YYYY-MM-DD");
        let date_to = moment(this.dates.date_to).format("YYYY-MM-DD");
        let basicLink = `https://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/getReportDocx`;
        this.modalReportVisible = true;


        getReportApi(`${basicLink}?thread_id=${this.$route.params.threadId}&date_from=${date_from}&date_to=${date_to}&type=${this.reportForm.typeReport}&format=${this.reportFileType}`).then(resp => {
            convert(resp.data)
        });
      },
      getSources() {
        getMetaSourcesApi({
          thread_id: this.$route.params.threadId,
          start: 0,
          limit: 100,
        }).then(resp => {
           console.log("111", resp.data)
            this.sourcesCount = resp.data.items.length;
        });
      }
    },
    computed: {
      ...mapGetters([
        'userLoginData',
      ])
    },
    beforeMount() {
      this.getSources();
    },
  };
</script>

<style>
  .post-report-wrap {
    padding: 20px 0 0 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .post-report-wrap__item {
    margin-bottom: 20px;
  }
  .post-report-wrap__item-link {
    width: 210px;
    height: 150px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .in_link-wrap {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
  }
  .in_link-wrap span {
    text-align: center;
    margin-top: 10px;
  }
  .report-link {
    font-family: "Roboto", "Arial", sans-serif;
    color: #000;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    text-decoration: none;
  }
  .el-dialog__body{
    word-break: break-word;
  }
  @media screen and (max-width: 480px) {
  .post-report-wrap__item-link{
    width: 172px;
  }
  }
</style>
